import React, { memo } from 'react';
export var ChevronBlock = /*#__PURE__*/memo(function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#fbb03b' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '45' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '58.616' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: width,
    height: height,
    viewBox: "0 0 45 58.616"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M741.409,248.069l13.325-13.325a.411.411,0,0,0,0-.581l-6.281-6.281a.411.411,0,0,0-.581,0l-19.9,19.9a.411.411,0,0,0,0,.581l19.9,19.9a.411.411,0,0,0,.581,0l6.281-6.281a.411.411,0,0,0,0-.581Z",
    transform: "translate(763.85 274.38) rotate(180)"
  })));
});